import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import $ from 'jquery';

export const useTracking = (trackingId) => {
  const { listen } = useHistory()

  useEffect(() => {
    const unlisten = listen((location) => {
        $('body').removeClass('scroll-off');

        if ($('.video-box.show-main')[0]){
          $('.video-box').addClass('hide').removeClass('show-main');
        }
  
        if ($('.prototype-box.show1')[0]){
          $('.prototype-box').addClass('hide1').removeClass('show1');
        }
  
        if ($('.prototype-box.show2')[0]){
          $('.prototype-box').addClass('hide2').removeClass('show2');
        }
  
        if ($('.contact-box.show-main')[0]){
          $('.contact-box').addClass('hide').removeClass('show-main');
        }
  
        if ($('.contact-box-result.show-main')[0]){
          $('.contact-box-result').addClass('hide').removeClass('show-main');
        }
      // if you pasted the google snippet on your index.html
      // you've declared this function in the global
      if (!window.gtag) return

      const path = location.pathname + location.hash;

      window.gtag('config', trackingId, { page_path: path })

//console.log('listenHook', path)
    })

    // remember, hooks that add listeners
    // should have cleanup to remove them
    return unlisten
  }, [trackingId, listen])
}